export default "__VITE_ASSET__Cy9zSqZg__"